export default {
  custom: {
    required: { type: Boolean, default: false },
    // xDense: { type: Boolean, default: false },
  },
  vuetify: {
    clearable: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    height: { type: [Number, String] },
    hideDetails: { type: Boolean, default: false },
    label: { type: String },
    outlined: { type: Boolean, default: false },
    value: { type: [Number, String] },
    appendIcon: { type: String },
    prependInnerIcon: { type: String },
    prependIcon: { type: String },
    rules: { type: Array }
  }
}